<template>
  <div>
    <p class="text-left mb-1 font-weight-medium">
      {{ dataField.title ? dataField.title : "" }}
    </p>
    <v-textarea
      clearable
      filled
      v-model="dataPost[fieldName ? fieldName.name : dataField.name]"
      :placeholder="dataField.placeHolder ? dataField.placeHolder : ''"
      :counter="dataField.params.count ? dataField.params.count : ''"
      @change="alerts[dataField.name] = null"
      :error="alerts[dataField.name] != null"
      :error-messages="alerts[dataField.name]"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: "TexArea",
  props: ["dataField", "fieldName"],
  computed: {
    dataPost: {
      get() {
        this.$store.commit("updateDataPost", this.$store.state.dataPost);
        return this.$store.state.dataPost;
      },
    },
    alerts: {
      get() {
        return this.$store.state.alerts;
      },
    },
  },
  data: () => ({
    required: [(v) => !!v || "this is required"],
  }),
};
</script>
